import { IChangePasswordRequest, IUser } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserService = sdk.getService('UserService');
const AuthService = sdk.getService('AuthService');

export const useMutateProfile = () => {
  const queryClient = useQueryClient();
  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['profile'] });
    queryClient.invalidateQueries({ queryKey: ['complete-profile-percentage'] });
  };

  const { mutate: updateProfile, isPending: isUpdating } = useMutation({
    mutationFn: (update: Partial<IUser>) => UserService.updateMe(update),
    onSuccess
  });

  const { mutate: changePassword, isPending: isChanging } = useMutation({
    mutationFn: (passwords: IChangePasswordRequest) => AuthService.changePassword(passwords),
    onSuccess
  });

  const { mutate: updateContract, isPending: isUpdatingContract } = useMutation({
    mutationFn: () => UserService.updateContract(),
    onSuccess
  });

  const { mutate: finishOnboarding, isPending: isFinishingOnboarding } = useMutation({
    mutationFn: () => UserService.finishOnboarding(),
    onSuccess
  });

  return {
    updateProfile,
    changePassword,
    updateContract,
    finishOnboarding,
    isWorking: isUpdating || isChanging || isUpdatingContract || isFinishingOnboarding
  };
};
